import { render } from "./Favorites.vue?vue&type=template&id=2202f51e&scoped=true"
const script = {}

import "./Favorites.vue?vue&type=style&index=0&id=2202f51e&lang=css&scoped=true"

import exportComponent from "/root/buildarea/v8-production-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2202f51e"]])

export default __exports__